import axios, { AxiosInstance } from 'axios'

export const authHttpClient = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_BASE_URL!,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

const addAppInfoRequestInterceptor = (httpClient: AxiosInstance) => {
  httpClient.interceptors.request.use(
    (requestConfig) => {
      requestConfig.headers.set('X-App-Info', 'ZocksConsole')
      return requestConfig
    },
    (error) => {
      console.error(error)
    },
  )
}

const addDataExtractInterceptor = (httpClient: AxiosInstance) => {
  httpClient.interceptors.response.use(
    (response) => {
      const contentType = String(response.headers['content-type'] ?? '')
      if (contentType.includes('text/html')) {
        return Promise.reject({
          htmlContent: response.data,
          contentType: 'text/html',
          statusCode: response.status,
          headers: response.headers,
        })
      }
      return response.data
    },
    (error) => {
      if (error?.contentType === 'text/html' && error?.htmlContent) {
        return Promise.reject(error)
      }

      const contentType = error.response?.headers?.['content-type'] || ''
      if (contentType.includes('text/html')) {
        return Promise.reject({
          htmlContent: error.response.data,
          contentType: 'text/html',
          statusCode: error.response.status,
          headers: error.response.headers,
        })
      }
      return Promise.reject({
        errorCode: error.code,
        statusCode: error.response?.status,
        ...error.response?.data,
      })
    },
  )
}

addDataExtractInterceptor(authHttpClient)
addAppInfoRequestInterceptor(authHttpClient)
